import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "spotter_token";

export const api = axios.create({ baseURL: API });

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common["Authorization"];
  }
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

const existing = getToken();
if (existing) api.defaults.headers.common["Authorization"] = `Bearer ${existing}`;

export function mediaUrl(u) {
  if (!u) return null;
  if (u.startsWith("http")) return u;
  return `${BACKEND_URL}${u}`;
}

// Pull the first external http(s) link out of some text (for link-preview cards).
// Skips our own app links so we never unfurl internal profile/post URLs.
export function extractFirstUrl(text) {
  if (!text) return null;
  const m = String(text).match(/https?:\/\/[^\s<]+/i);
  if (!m) return null;
  const u = m[0].replace(/[.,!?;:)\]}'"]+$/, "");
  try {
    const h = new URL(u).hostname;
    if (/(^|\.)(thetopspotter\.com|spotter-network\.[^/]*|emergent\.host|emergentagent\.com|emergentagent\.net)$/i.test(h)) return null;
  } catch (e) { return null; }
  return u;
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

// Leopard backgrounds members can pick
export const LOGO = "https://customer-assets.emergentagent.com/job_spotter-network/artifacts/gp7xudj1_ChatGPT_Image_Jul_12__2026__11_18_04_PM-removebg-preview.png";
export const LEOPARD_ORANGE = "https://customer-assets.emergentagent.com/job_spotter-network/artifacts/5dr1w39q_leopard-pattern-fur-texture%20%281%29%20%282%29%20%281%29%20%281%29.jpg";
export const APP_BG = "https://customer-assets-wrfwihn1.emergentagent.net/job_spotter-network/artifacts/zd3cu3vp_leopard-pattern-fur-texture.webp";
export const BACKGROUNDS = {
  orange: { label: "Wild Fur", url: LEOPARD_ORANGE },
  blue: { label: "Ice Blue", url: "https://customer-assets.emergentagent.com/job_spotter-network/artifacts/uxhjjtex_095f22ebb000f2973b2e4e616f3b036e.jpg" },
  pink: { label: "Hot Pink", url: "https://customer-assets.emergentagent.com/job_spotter-network/artifacts/6r1d9w2i_pink-leopard-print-6pm1on0zk6jjwucp.jpg" },
  coral: { label: "Coral", url: "https://customer-assets.emergentagent.com/job_spotter-network/artifacts/hw6oqduv_b91cc1f479438a2f97da64afac1aff62.jpg" },
};
export function bgUrl(key) {
  return (BACKGROUNDS[key] || BACKGROUNDS.orange).url;
}

export const REACTIONS = [
  { type: "paw", label: "Paw", color: "#E19C00", icon: "PawPrint" },
  { type: "fire", label: "Fire", color: "#E2571f", icon: "Flame" },
  { type: "heart", label: "Heart", color: "#E0245E", icon: "Heart" },
  { type: "wow", label: "Wow", color: "#F7B125", icon: "Star" },
  { type: "sad", label: "Sad", color: "#5B8DEF", icon: "Frown" },
  { type: "dislike", label: "Dislike", color: "#657786", icon: "ThumbsDown" },
];

// Quick emoji palette for status / posts
export const EMOJIS = ["😀","😂","😍","🥹","😎","😭","😡","🤔","🙌","🔥","💛","🐆","✨","🎉","💯","👀","🥳","😴","🤝","💪"];

// Feelings / activities (Facebook-style)
export const FEELINGS = [
  { emoji: "😊", label: "feeling happy" },
  { emoji: "🥰", label: "feeling loved" },
  { emoji: "😎", label: "feeling cool" },
  { emoji: "😢", label: "feeling sad" },
  { emoji: "😡", label: "feeling angry" },
  { emoji: "🤩", label: "feeling excited" },
  { emoji: "😴", label: "feeling tired" },
  { emoji: "🙏", label: "feeling thankful" },
  { emoji: "🍿", label: "watching a movie" },
  { emoji: "🎵", label: "listening to music" },
  { emoji: "🎮", label: "playing games" },
  { emoji: "✈️", label: "travelling" },
  { emoji: "🍔", label: "eating" },
  { emoji: "💪", label: "working out" },
  { emoji: "📚", label: "reading" },
  { emoji: "🎉", label: "celebrating" },
];
